import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["type", "disabled", "aria-busy"]
const _hoisted_2 = {
  key: 0,
  class: "app-loading-button-content"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "app-loading-button-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: _ctx.type,
    disabled: _ctx.isDisabled,
    "aria-busy": _ctx.loading ? 'true' : 'false',
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("i", {
            class: "fa fa-spinner fa-spin",
            "aria-hidden": "true"
          }, null, -1)),
          (_ctx.loadingLabel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.loadingLabel), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ], true)
        ]))
  ], 8, _hoisted_1))
}